// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"25e4af87","427":"5dfd7e06","511":"1684d4bb","644":"c48d8d8a","655":"cc594584","695":"5dfd7e06","804":"7bbd2ea5"}[chunkId] + ".chunk.css";
};